import React from 'react';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import './DraggableCard.styles.scss';
import './DraggableCard.styles.responsive.scss';

type DraggableCardProps = {
  className?: string;
  id: string;
  disabled?: boolean;
  includeResize?: boolean;
  dragEnabled?: boolean;
};

const DraggableCard: React.FC<DraggableCardProps> = (props) => {
  const {
    id,
    children,
    className,
    disabled,
    includeResize = false,
    dragEnabled = true,
  } = props;

  const {
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
    isSorting,
    setNodeRef,
  } = useSortable({ id, disabled });

  const cleanTransform = includeResize
    ? transform
    : { ...transform, scaleX: 1, scaleY: 1 };

  const style = {
    ...((isDragging || isSorting) && {
      transition,
      transform: CSS.Transform.toString(cleanTransform),
    }),
  };

  const classes = classNames(
    'draggable-card',
    { 'draggable-card--dragging': isDragging },
    className,
  );

  return (
    <div
      className={classes}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...(dragEnabled && listeners)}
    >
      {children}
    </div>
  );
};

export default DraggableCard;
